import { useTranslation } from 'i18next-vue';
import { isPublicPageApp } from '@/utilities/isPublicPageApp';

export default function useTranslate() {
  let translate: TranslateFn = (key) => {
    return key;
  };
  if (!isPublicPageApp()) {
    const { t } = useTranslation();
    if (t) {
      translate = t as TranslateFn;
    }
  }
  return {
    translate,
  };
}

export type TranslateFn = (key: string, interpolations?: Record<string, any>) => string;
